<template>
  <div class="transfer-order-apply">
    <el-form ref="form" :model="form" :rules="rules" label-position="top">
      <div class="form-box">
        <div class="form-title">
          {{ $t('components_transfer_order_apply.chu_ku_fang_xin_xi') }}
        </div>
        <div class="form-container info-container">
          <el-row>
            <el-col>
              <el-form-item :label="$t('components_transfer_order_apply.chu_ku_fang')" prop="outOrgId">
                <custom-select
                  filterable
                  v-if="!isPreview"
                  :props="{ label: 'partnerName', value: 'partnerOrgId' }"
                  url="transferOrderOutOrgList"
                  v-model="form.outOrgId"
                  @change="outOrgChange"
                  @getList="onGetOutOrgList"
                  :disabled="isPreview"
                  placeholder=""
                ></custom-select>
                <el-input v-else :value="info.outOrgName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item :label="$t('components_transfer_order_apply.sqdbgsdz')" prop="outCompanyAddress">
                <el-input type="textarea" :value="outCompanyAddress" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="form-box">
        <div class="form-title">{{ $t('components_transfer_order_apply.ru_ku_fang_xin_xi') }}</div>
        <div class="form-container info-container">
          <el-row>
            <el-col>
              <el-form-item :label="$t('components_transfer_order_apply.rkfmc')" prop="inOrgName">
                <el-input v-model="form.inOrgName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item :label="$t('components_transfer_order_apply.ye_wu_fu_ze_ren')" prop="contactName">
                <el-input v-model="form.contactName" :disabled="isPreview"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('components_transfer_order_apply.lian_xi_dian_hua')" prop="contactPhone">
                <el-input v-model="form.contactPhone" :disabled="isPreview"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item :label="$t('components_transfer_order_apply.rkfgsdz')" prop="inCompanyAddress">
                <el-input v-if="!isPreview" type="textarea" v-model="form.inCompanyAddress" :disabled="true" prop="inCompanyAddress"></el-input>
                <el-input v-else disabled :value="info.inOrgInfo ? info.inOrgInfo.address : ''"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item :label="$t('components_transfer_order_apply.shou_huo_ren')" prop="consigneeName">
                <el-input v-model="form.consigneeName" :disabled="isPreview"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('components_transfer_order_apply.lian_xi_dian_hua')" prop="consigneePhone">
                <el-input v-model="form.consigneePhone" :disabled="isPreview"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item :label="$t('components_transfer_order_apply.shou_huo_di_zhi')">
                <custom-address-select v-model="form.addressCode" ref="addressSelect" :disabled="isPreview"></custom-address-select>
                <el-input type="textarea" v-model="form.detailAddress" class="detail-address" :disabled="isPreview"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="form-box">
        <div class="form-title">
          {{ $t('components_transfer_order_apply.tiao_bo_xin_xi') }}
        </div>
        <div class="form-container info-container">
          <el-row>
            <el-col>
              <el-form-item :label="$t('components_transfer_order_apply.sbsydz')" prop="useLocation">
                <el-input type="textarea" v-model="form.useLocation" :disabled="isPreview"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item :label="$t('components_transfer_order_apply.tiao_bo_yuan_yin')" prop="transferReason">
                <el-input type="textarea" v-model="form.transferReason" :disabled="isPreview"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="form-box">
        <div class="form-title">
          {{ $t('components_transfer_order_apply.tiao_bo_ming_xi') }}
        </div>
        <div class="form-container info-container">
          <div class="table-hd">
            <el-table :data="form.goodsList">
              <el-table-column :label="$t('components_transfer_order_apply.sbywlx')" width="160px">
                <template slot-scope="scope">
                  <custom-select code="dms_device_biz_type" v-model="scope.row.deviceBizType" :placeholder="$t('components_transfer_order_apply.qxzsbywlx')" :disabled="isPreview"></custom-select>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components_transfer_order_apply.chan_pin_xing_hao')" width="180px">
                <template slot-scope="scope">
                  <custom-select
                    url="productCodeSelectList"
                    v-model="scope.row.productCode"
                    :placeholder="$t('components_transfer_order_apply.qxzcpxh')"
                    :props="{ label: 'productName', value: 'productCode' }"
                    :disabled="isPreview"
                    @change="onChangeProduct($event, scope.row)"
                  ></custom-select>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components_transfer_order_apply.chan_pinSN')">
                <template slot-scope="scope">
                  <custom-select
                    ref="productSn"
                    :listener="scope.row.productCode"
                    multiple
                    v-model="scope.row.productSnArr"
                    url="productSnList"
                    :params="{ productCodes: scope.row.productCode ? [scope.row.productCode] : [] }"
                    :props="{ label: 'productSn', value: 'productSn' }"
                    :placeholder="$t('components_transfer_order_apply.qxzcpSNfbywxxz')"
                    :disabled="isPreview"
                    @change="onChangeProductSn($event, scope.row)"
                  ></custom-select>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components_transfer_order_apply.shu_liang')" width="120px">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.bookingNum" :min="0" :disabled="isPreview"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('Common.com_handle')" v-if="!isPreview" width="100px">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="delRow(scope.$index)">{{ $t('Common.com_delete') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="add-row" @click="addRow" v-if="!isPreview">
              <i class="el-icon-plus el-icon--left"></i>
              {{ $t('components_transfer_order_apply.tian_jia_xing') }}
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <!-- 选择地址 -->
    <contractManagement-chooseAddress-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="addAddress"></contractManagement-chooseAddress-dialog>
  </div>
</template>

<script>
/** 库存调拨申请 */
import dialogMixins from '@/mixins/dialog_mixins';
import contractManagementChooseAddressDialog from '@/pages/crm/components/chooseAddressDialog.vue';
import customAddressSelect from '@/components/customAddressSelect';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {
    contractManagementChooseAddressDialog,
    customAddressSelect,
  },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch,
          changeId: '', // 编辑，预览时为orderId, 新增不用传
        };
      },
    },
  },
  data() {
    return {
      // 出库方列表
      outOrgList: [],
      form: {
        afterService: {
          detailAddress: '',

          // 下拉相关信息-提交表单
          deliverAddressId: '',
          version: '',

          // 下拉相关信息-界面显示
          consigneeName: '',
          consigneePhone: '',

          partnerOrgId: '',
        },

        // 调拨明细
        goodsList: [],

        // 出库方
        outOrgId: '',
        // 出库方组织名称
        outOrgName: '',
        outOrgCode: '',
        // 出库方详细地址信息
        outOrgAddressId: '',
        outOrgAddressVersion: '',
        // 授权代表公司地址 不需要提交  需要从select中获取
        outCompanyAddress: '',

        // 入库方名称
        inOrgName: '',
        inOrgId: '',
        inOrgCode: '',
        // 业务负责人
        contactName: '',
        // 联系电话
        contactPhone: '',
        // 入库方公司地址 不需要提交  从入库列表接口接口获取
        inCompanyAddress: '',
        // 收货人
        consigneeName: '',
        // 联系电话
        consigneePhone: '',
        // 收货地址
        detailAddress: '',
        // 收货地址下拉
        addressCode: [],

        // 设备使用地址
        useLocation: '',
        // 调拨原因
        transferReason: '',

        orderId: '',
        orderRemark: '',
        countryCode: '',
        provinceCode: '',
        cityCode: '',
      },

      selectData: [
        {
          label: '1',
          value: 1,
        },
      ],

      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      info: {},
      disabledListen: true,
    };
  },
  computed: {
    rules() {
      return {
        outOrgId: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        contactName: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
        ],
        contactPhone: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 15,
            message: this.$t('Common.com_rules_length_max', [15]),
          },
        ],
        consigneeName: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
        ],
        consigneePhone: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 15,
            message: this.$t('Common.com_rules_length_max', [15]),
          },
        ],
        detailAddress: {
          max: 200,
          message: this.$t('Common.com_rules_length_max', [200]),
        },
        useLocation: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        transferReason: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
    isPreview() {
      return this.model.type === 'watch';
    },
    outCompanyAddress() {
      const item = this.outOrgList.find((obj) => obj.partnerOrgId === this.form.outOrgId);
      if (item) {
        return this.getAddress(item);
      }
      const outOrgInfo = this.info.outOrgInfo;
      return this.getAddress(outOrgInfo);
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onChangeProduct: function (item, row) {
      if (this.disabledListen) {
        return;
      }
      row.productSnArr = [];
    },
    onChangeProductSn: function (item, row) {
      if (this.disabledListen) {
        return;
      }
      row.productSns = item.map((t) => t.productSn).join(',');
    },
    onGetOutOrgList(list) {
      this.outOrgList = list;
    },
    // 删除行
    delRow(index) {
      this.form.goodsList.splice(index, 1);
    },
    /**
     * @description 校验表单
     * @param {function} cb 检测回调，回调参数为boolean
     */
    checkForm(cb) {
      if (this.form.goodsList.find((item) => !item.productCode)) {
        this.$message.error(this.$t('components_transfer_order_apply.qtxtbmx'));
        cb(false);
        return;
      }
      if (this.form.goodsList.find((item) => !item.deviceBizType)) {
        this.$message.error(this.$t('components_transfer_order_apply.qtxsbywlx'));
        cb(false);
        return;
      }
      cb(true);
    },
    addAddress(arg) {
      const item = arg[0];

      this.form.afterService.deliverAddressId = item.deliverAddressId; // 地址ID
      this.form.afterService.version = item.version; // 地址版本
      this.form.afterService.consigneeName = item.consigneeName; // 收货人
      this.form.afterService.consigneePhone = item.consigneePhone; // 收货人电话
      this.form.afterService.detailAddress = `${item.country}${item.province}${item.city}${item.detailAddress}`; // 详细地址

      this.form.outOrgAddressId = item.deliverAddressId; // 地址ID
      this.form.outOrgAddressVersion = item.version; // 地址版本
    },
    changeAddress() {
      if (this.isPreview) {
        return;
      }
      if (!this.form.outOrgId) {
        this.$message.error(this.$t('components_transfer_order_apply.qxxzckf'));
        return;
      }
      this.dialogModel = {
        title: this.$t('components_transfer_order_apply.xuan_ze_di_zhi'),
        data: {
          partnerOrgId: this.form.outOrgId,
        },
      };

      this.dialogVisible = true;
    },
    outOrgChange(item) {
      this.form.outCompanyAddress = item.address || '';

      const partnerDeliverAddress = item.partnerDeliverAddress || {};
      this.form.afterService.detailAddress = `${partnerDeliverAddress.country}${partnerDeliverAddress.province}${partnerDeliverAddress.city}${partnerDeliverAddress.detailAddress}`; // 详细地址;
      this.form.afterService.deliverAddressId = partnerDeliverAddress.deliverAddressId;
      this.form.afterService.version = partnerDeliverAddress.version;
      this.form.afterService.consigneeName = partnerDeliverAddress.consigneeName;
      this.form.afterService.consigneePhone = partnerDeliverAddress.consigneePhone;

      // 地址ID
      this.form.afterService.partnerOrgId = item.partnerOrgId;
      this.form.outOrgAddressId = partnerDeliverAddress.deliverAddressId; // 地址ID

      /** 修改入库信息 */
      if (item.busLeaderName && !this.form.contactName) {
        this.form.contactName = item.busLeaderName;
      }
      if (item.busLeaderPhone && !this.form.contactPhone) {
        this.form.contactPhone = item.busLeaderPhone;
      }

      this.updateOutOrg(item);
    },
    // 获取入库方基础信息
    getOrgInInfo() {
      // 接口返回一个对象
      this.$getJSON(apis.transferOrderInOrgList).then((res) => {
        const data = res.data || {};
        const { partnerName = '', partnerOrgId = '', partnerCode = '', busLeaderName = '', busLeaderPhone = '' } = data;
        this.form.inOrgName = partnerName;
        this.form.inOrgId = partnerOrgId;
        this.form.inOrgCode = partnerCode;
        this.form.contactName = busLeaderName;
        this.form.contactPhone = busLeaderPhone;
        this.form.inCompanyAddress = this.getAddress(data);
      });
    },
    updateOutOrg(item) {
      this.$getJSON(apis.transferOrderInOrgList, {
        outOrgId: item.partnerOrgId,
      }).then((res) => {
        const data = res.data;
        this.form.inOrgName = data.partnerName;
        this.form.inOrgId = data.partnerOrgId;
        this.form.inOrgCode = data.partnerCode;

        this.form.inCompanyAddress = data.address;
      });
    },
    getReqData(isStartApprove) {
      const addressSelectData = this.$refs.addressSelect.getAddressMsg();
      // 出库方信息
      const partnerOrgItem = this.outOrgList.find((item) => item.partnerOrgId === this.form.outOrgId);
      const ret = {
        ...this.form,
        ...addressSelectData,
        outOrgName: partnerOrgItem.partnerName,
        outOrgCode: partnerOrgItem.partnerCode,
        isStartApprove,
      };

      delete ret.addressCode;
      delete ret.afterService;
      delete ret.inCompanyAddress;
      delete ret.outCompanyAddress;

      return ret;
    },
    onSubmit() {
      this.onSaveDraft(true);
    },
    init() {
      if (this.model.type === 'add') {
        this.addRow();
        this.$nextTick(() => {
          this.disabledListen = false;
        });
      } else {
        this.getPageInfo();
      }
    },
    getAddress(info) {
      if (info) {
        if (info.address) {
          return info.address;
        } else {
          if (info.detailAddress) {
            const { country, province, city, detailAddress } = info;
            return [country, province, city, detailAddress].join('');
          }
        }
      }
      return '';
    },
    getPageInfo() {
      this.$getJSON(apis.transferOrderInfo, {
        orderId: this.model.changeId,
      }).then((res) => {
        this.info = res.data;

        const goodsList = (res.data.goodsList || []).map((t) => ({ ...t, productSnArr: t.productSns ? t.productSns.split(',') : [] }));

        this.$setFormatData(this.form, Object.assign(res.data || {}, { goodsList }));
        if (res.data.countryCode) {
          this.form.addressCode.push(res.data.countryCode);
        }
        if (res.data.provinceCode) {
          this.form.addressCode.push(res.data.provinceCode);
        }
        if (res.data.cityCode) {
          this.form.addressCode.push(res.data.cityCode);
        }
        if (res.data.outOrgAddress) {
          const outOrgAddress = res.data.outOrgAddress;
          this.form.afterService.detailAddress = `${outOrgAddress.country}${outOrgAddress.province}${outOrgAddress.city}${outOrgAddress.detailAddress}`; // 详细地址;
          this.form.afterService.deliverAddressId = outOrgAddress.deliverAddressId;
          this.form.afterService.version = outOrgAddress.version;
          this.form.afterService.consigneeName = outOrgAddress.consigneeName;
          this.form.afterService.consigneePhone = outOrgAddress.consigneePhone;
          this.form.afterService.partnerOrgId = outOrgAddress.partnerOrgId;

          this.form.outOrgAddressId = outOrgAddress.deliverAddressId;
          this.form.outOrgAddressVersion = outOrgAddress.version;
        }

        setTimeout(() => {
          this.$nextTick(() => {
            this.disabledListen = false;
          });
        }, 1500);
      });
    },
    addRow() {
      if (this.isPreview) {
        return;
      }
      this.form.goodsList.push({
        productCode: '',
        productSnArr: [],
        productSns: '',
        bookingNum: 0,
        deviceBizType: '',
      });
    },
    onSaveDraft(isStartApprove) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.checkForm((val) => {
            if (val) {
              const reqData = this.getReqData(isStartApprove);
              this.$postJSON(apis.transferOrderApply, reqData, true).then(() => {
                const msg = this.model.type === 'add' ? this.$t('Common.com_add_success') : this.$t('Common.com_edit_success');
                this.$message({
                  type: 'success',
                  message: msg,
                });
                this.$emit('success');
              });
            }
          });
        }
      });
    },
    onConfirm(isStartApprove) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.onSaveDraft(isStartApprove);
    },
  },
  created() {},
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.transfer-order-apply {
  .add-row {
    margin-top: 16px;
    width: 100%;
    background: #f5f5f7;
    border: 1px #e4e4e4 dashed;
    height: 40px;
    line-height: 38px;
    text-align: center;
    font-size: 12px;
    color: #495057;
    &:hover {
      cursor: pointer;
    }

    .el-icon-plus {
      color: #0d9ae0;
      font-weight: bold;
    }
  }

  .form-box {
    margin-top: 35px;
    position: relative;
    border: 1px solid rgba(13, 154, 224, 0.3);
    padding: 35px 0 32px;
    .form-title {
      font-size: 12px;
      font-weight: 600;
      color: rgba(13, 154, 224, 1);
      line-height: 20px;
      height: 20px;
      position: absolute;
      top: -10px;
      left: 16px;
      background: #ffffff;
      padding: 0 10px;
    }
    .form-container {
      padding: 0 24px;
      .party-a,
      .party-b,
      .contract-a,
      .contract-b {
        padding: 0 24px;
        width: 440px;
        box-sizing: content-box;
      }
      .party-b,
      .contract-b {
        border-left: 1px solid #eef2f8;
      }
      // 甲乙方信息
      .address-box {
        cursor: pointer;
        overflow: hidden;
        border: 2px dashed #00afff;
        position: relative;
        height: 80px;

        color: rgba(0, 0, 0, 0.45);
        > h3 {
          color: #000;
          padding-bottom: 16px;
          line-height: 24px;
        }
        .address-modify-btn {
          position: absolute;
          bottom: 10px;
          font-size: 12px;
          color: #f33a73;
          cursor: pointer;
        }

        .address-btn {
          line-height: 80px;
          font-size: 40px;
          text-align: center;
        }

        .address-item {
          padding: 12px 16px;

          h3 {
            line-height: 24px;
            color: #1e1e1e;
            font-size: 12px;
            font-weight: bold;
          }

          p {
            font-size: 12px;
            line-height: 24px;
            color: #666;
            margin-top: 8px;
            padding-right: 30px;
          }
          .address-modify-btn {
            position: absolute;
            bottom: 10px;
            font-size: 12px;
            color: #f33a73;
            cursor: pointer;
            right: 16px;
            bottom: 6px;
          }
        }
      }
    }
    .info-container {
      padding: 0 24px;
      box-sizing: content-box;

      .detail-address {
        margin-top: 10px;
      }
    }
  }
}
</style>
